import { createContext, useContext, useEffect, useState } from 'react';
import { login, register, logout, refreshToken } from '../services/Auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWebSocket } from '../hooks/useWebSocket';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const { socket, connect, disconnect } = useWebSocket();
    const location = useLocation();

    // Verificar sesión al cargar
    useEffect(() => {
        const publicRoutes = ['/', '/login', '/register'];
        const isPublicRoute = publicRoutes.includes(location.pathname);

        const checkSession = async () => {
            try {
                if (!isPublicRoute) {
                    const res = await refreshToken();
                    setUser(res.data.user);
                    connect(res.data.token);
                    navigate('/chat');
                }
            } catch (error) {
                setUser(null);
                if (!isPublicRoute) {
                    navigate('/login');
                }
            }
        };
        checkSession();
    }, [navigate, connect, location.pathname]);

    // Desconectar el socket al cerrar sesión
    useEffect(() => {
        return () => disconnect();
    }, [disconnect]);

    const handleLogin = async (userData) => {
        try {
            const res = await login(userData);
            setUser(res.data.user);
            connect(res.data.token);
            navigate('/chat');
        } catch (error) {
            console.error(error.response?.data?.message || "Error al iniciar sesión");
        }
    };

    const handleRegister = async (userData) => {
        try {
            const res = await register(userData);
            setUser(res.data.user);
            connect(res.data.token);
            navigate('/chat');
        } catch (error) {
            console.error(error.response?.data?.message || "Error al registrarse");
        }
    };

    const handleLogout = async () => {
        await logout();
        setUser(null);
        disconnect();
        navigate('/login');
    };

    return (
        <AuthContext.Provider value={{
            user,
            socket,
            handleLogin,
            handleRegister,
            handleLogout
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);